import { render, staticRenderFns } from "./KIncludeButton.vue?vue&type=template&id=06cbf72d&"
import script from "./KIncludeButton.vue?vue&type=script&lang=js&"
export * from "./KIncludeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports